const PIVOTED_TABLE_DYNAMIC_HEADINGS = ["Practitioner NPI", "TIN"];

export const isColumnDynamicHeader = label =>
  PIVOTED_TABLE_DYNAMIC_HEADINGS.includes(label);

export const formatColumnForFilter = columnName =>
  columnName?.toLowerCase()?.split(" ")?.join("_");
